<template>
    <b-button @click.stop="emitClickEvent" :block="block" :disabled="disabled || loading" :class="'cin-big-button ' + type + (fitInput ? ' join ' : '')">
        <div v-if="!loading" class="d-flex flex-column justify-content-center align-items-center h-100 w-100 info-container">
            <icon v-if="icon && icon.name" :color="icon.color" :name="icon.name" :scale="icon.scale" :flip="icon.flip" />
            <span>{{ text }}</span>
        </div>

        <b-spinner v-else small variant="light" :loading="true" />
    </b-button>
    <!-- d-flex flex-column align-items-center justify-content-center -->
</template>
<script>
/**
 * Summary.
 * Use this component to mount a CIN default button.
 *
 * @param {String} text - Text value of the button.
 * @param {String} type - Possible values: red | blue | yellow | black | primary-dark-1.
 *
 * @param {Boolean} disabled - If the button is disabled.
 * @param {Boolean} loading - Controls when to shows a loading indicator inside the button.
 * @param {Boolean} block - The button will use all available width
 * @param {Boolean} fitInput - Set the top and bottom left corners-radius to 0.
 *
 * @param {Object} icon - The icon Object containing name and scale.
 *
 * @event click - On button click.
 */

export default {
    name: 'CustomButton',
    props: {
        text: String,
        type: {
            type: String,
            default: 'blue',
        },

        disabled: Boolean,
        loading: Boolean,
        block: Boolean,
        fitInput: Boolean,

        icon: Object,
    },
    methods: {
        /**
         * Summary.
         * Use this method to emit a new button click.
         *
         * @param {Object} event - The click event object.
         */
        emitClickEvent(event) {
            this.$emit('click', event)
        },
    },
}
</script>
<style lang="scss" scoped>
@import '@/scss/components/Utils/custom-fat-button.scss';
</style>
